import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isModalOpen: false,
    site: null,
    version: '',
    sortedBy: 'date',
    loading: false
  },
  mutations: {
    toggleModal(state, payload) {
      state.isModalOpen = !state.isModalOpen
      payload ? state.site = payload.site : state.siteUid = null
    },
    closeModals(state){
      state.isModalOpen = false
    },
    setVersion(state, payload) {
      state.version = payload.name
    },
    toggleLoading(state) {
      state.loading = !state.loading 
    },
    setSorted(state, payload) {
      state.sortedBy = payload.name
    }
  },
  actions: {

  }
})
